import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { constant, debounce } from 'lodash';
import { PackagetourService } from 'src/app/api/tourism/packagetour.service';
import * as _ from 'underscore';
declare var $: any;

@Component({
  selector: 'component-search-packagetour',
  templateUrl: './search-packagetour.component.html',
  styleUrls: ['./search-packagetour.component.css']
})
export class SearchPackagetourComponent implements OnInit {
  @ViewChild('searchInput') searchInput: any;
  @Output() selectedPackagetourEvent = new EventEmitter<string>();
  @Input() classSize: string | null = null;

  data = [];
  keyword = 'description';
  isTypedSearch = false;
  classSearch:any;

  constructor(private packagetourService: PackagetourService) {}

  ngOnInit() {
    this.classSearch = this.classSize; 
  }

  debouncedSearchInput = debounce(event => this.getSearchTours(event), 250);

  getSearchTours(search_: any) {
    this.isTypedSearch = true;
    if (search_.length > 1) {
      let val_params = 'search=' + search_;
      this.packagetourService.search(val_params).subscribe({
        next: (data: any) => {
          this.data = data.results;
        }
      });
    } else {
      this.data = [];
    }
  }

  selectSearch(item: any) {
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
      (<any>$('.autocomplete-container .not-found')).hide();
    }, 10);
    
    this.selectedPackagetourEvent.emit(item);
    this.data = [];
    this.searchInput.clear();
    this.searchInput.focus();
  }

  closedSearchPanel(): void {
    this.data = [];
    this.isTypedSearch = false;
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
    }, 10);
  }

  clearedInputSearch(): void {
    this.searchInput.focus();    
    this.data = [];
    this.isTypedSearch = false;
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
    }, 10);
  }

  focused() {
    this.searchInput.focus(); 
  }
}
